import { render } from "./factory_to_ic7.vue?vue&type=template&id=22ac8cd8&scoped=true"
import script from "./factory_to_ic7.vue?vue&type=script&lang=js"
export * from "./factory_to_ic7.vue?vue&type=script&lang=js"

import "./factory_to_ic7.vue?vue&type=style&index=0&id=22ac8cd8&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ac8cd8"]])

export default __exports__